import { langIf } from './types';
const en: langIf = {
  title: 'Pokémon SV clock',
  description: 'Pokémon Scarlet/Violet (SV) in-game time clock app',
  createFirstClock: 'Create your first clock',
  createInGameClock: 'Create in-game clock',
  openMapView: 'Open Map view to check the in-game time.',
  inGameTimeisDifferentForEachSave:
    'In-game time is different for each saved data.',
  selectCurrentInGameTime: 'Select current in-game time.',
  pressSubmitWhenTimeChanged: 'Press submit when in-game time change to',
  morning: 'Morning',
  day: 'Day',
  evening: 'Evening',
  night: 'Night',
  back: 'Back',
  close: 'Close',
  next: 'Next',
  privacyPolicy: 'Privacy Policy',
  beforeUsing: 'Before using this app, please agree to the following document.',
};
export default en;
